import { createContext } from 'react'

const context = createContext({
  active: false,
  toggle: () => {}
})

const { Provider, Consumer } = context

export { Provider, Consumer }

export default context
